import React from 'react';

const PricingFeatures = () => {
    return (
        <section className="divider-top">
            <div className="stg-row stg-bottom-gap-l">
                <div className="stg-col-6 stg-offset-3 align-center">
                    <h2 data-split-appear="fade-up" data-unload="fade-up">Here's how we make brand magic accessible</h2>
                </div>
            </div>
            <div className="infocolors-grid-3cols infocolors-tp-grid-2cols infocolors-tp-stretch-last-item" data-stagger-appear="fade-up" data-delay="100" data-stagger-unload="fade-up">
                <div className="infocolors-block stg-aspect-square stg-vertical-space-between">
                    <h5>Transparent pricing<span className="infocolors-accent">.</span></h5>
                    <p className="infocolors-large-text infocolors-tp-normal-text" >Upfront pricing models with detailed breakdowns, so you know exactly where it goes.</p>
                </div>
                <div className="infocolors-block stg-aspect-square stg-vertical-space-between">
                    <h5>Customizable packages<span className="infocolors-accent">.</span></h5>
                    <p className="infocolors-large-text infocolors-tp-normal-text" >No cookie-cutter plans. We craft solutions that perfectly match your resources.</p>
                </div>
                <div className="infocolors-block stg-aspect-square stg-vertical-space-between">
                    <h5>Scalable support<span className="infocolors-accent">.</span></h5>
                    <p className="infocolors-large-text" >Whether you're a startup or an established brand, we offer services that grow with you.</p>
                </div>
            </div>
        </section>
    );
};

export default PricingFeatures;
